/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Property market condition.
 */
export enum PropertyCondition {
    USED = 'USED',
    NEW = 'NEW',
}
